import { notification } from "antd";
import { IconType } from "antd/es/notification/interface";
import { RouteNames } from "~/app/providers/router/config/routeConfig";

export function showNotificationByPage(pathname: RouteNames, type: IconType, message: string, description = '') {
  if (window.location.pathname === pathname) {
    notification[type]({ message, description });
  }
}
